import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const serviceDetails = async (lang, serviceId) => {
  try {
    // Remove "SERVICE#" prefix if present
    const cleanServiceId = serviceId?.replace(/^SERVICE#/, '');

    const token = sessionStorage.getItem('token');
    const API_URL = `${apiUrl}/api/v1/serviceDetails/getServiceData/${cleanServiceId}?lang=${lang}`;

    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching service details:", error);
    throw error;
  }
};

export default { serviceDetails };
